import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { getPosts } from "@/data/blogPosts";
import { useLang } from "@/i18n/LanguageContext";

export default function BlogTeaser() {
  const { t, lang } = useLang();
  const b = t.blog;
  const posts = [...getPosts(lang)].sort((a, c) => c.date.localeCompare(a.date)).slice(0, 3);

  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32" data-testid="blog-teaser-section">
      <Reveal className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
            <Star size={11} /> {b.kicker}
          </p>
          <h2 className="mt-5 max-w-xl font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="blog-teaser-title">
            {b.teaserTitle}
          </h2>
        </div>
        <Link
          to="/blog"
          data-testid="blog-teaser-viewall"
          className="gold-underline w-fit text-sm font-medium"
          style={{ color: "var(--camel)" }}
        >
          {b.viewAll} →
        </Link>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {posts.map((post, i) => (
          <Reveal key={post.slug} delay={i * 0.1}>
            <Link
              to={`/blog/${post.slug}`}
              data-testid={`blog-teaser-card-${post.slug}`}
              className="group flex h-full flex-col overflow-hidden rounded-3xl border transition-shadow duration-500 hover:shadow-[0_24px_48px_-24px_rgba(198,156,109,0.4)]"
              style={{ background: "var(--surface-secondary)", borderColor: "var(--line)" }}
            >
              <div className="h-44 overflow-hidden">
                <img src={post.image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-3 text-[10px] uppercase font-bold" style={{ letterSpacing: "0.1em" }}>
                  <span className="rounded-full border px-3 py-1" style={{ borderColor: "var(--gold)", color: "var(--camel)" }}>{post.category === "B2B" ? b.catB2B : b.catB2C}</span>
                  <span style={{ color: "var(--muted-warm)" }}>{post.readTime} {b.min}</span>
                </div>
                <h3 className="mt-3 flex-1 font-serif-display text-lg font-semibold leading-snug">{post.title}</h3>
                <span className="mt-4 flex items-center gap-1.5 text-sm font-medium transition-transform duration-300 group-hover:translate-x-1" style={{ color: "var(--camel)" }}>
                  {b.readMore} <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
